import {
  Component,
  HostBinding,
  Input,
  signal,
  WritableSignal,
} from '@angular/core';
import { BaseWidget } from '../base-widget/base-widget';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ActionEnum } from '@app/core/dto/abstract-action.dto';
import { StringUtils } from '@app/core/utils/string.utils';
import { NavigationOptions } from '@app/core/enums/navigation-options.enum';

@Component({
  selector: 'ib-credit-order-card',
  imports: [CommonModule],
  templateUrl: './ib-credit-order-card.component.html',
  styleUrl: './ib-credit-order-card.component.scss',
})
export class IbCreditOrderCardComponent extends BaseWidget {
  @HostBinding('class') @Input() ngClass: any;
  @HostBinding('style') @Input() ngStyle: any;

  @Input() actionEvent: (event: any) => void;
  @Input() slot: any;
  isSettlementOpen: { [key: string]: boolean } = {};

  data: WritableSignal<any> = signal(null);
  constants: WritableSignal<any> = signal(null);
  prevDropdown: WritableSignal<string> = signal(null);

  StringUtils = StringUtils;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.data.set(this.slot?.widget?.data.orders);
    this.constants.set(this.slot.widget.data.constants);
    if (isPlatformBrowser(this.platformId)) {
      if (this.data()?.[0]?.payDirectly) {
        this.payNow(this.data()?.[0]?.invoice_id);
      }
      if (this.slot?.widget?.data?.payAllDirectly) {
        this.payNow();
      }
    }
  }

  seeInvoice(uploadedFileUrl: string) {
    this.actionEvent({
      actionData: {
        type: ActionEnum.EXTERNAL_NAVIGATION,
        params: {
          url: uploadedFileUrl,
          navigationOption: NavigationOptions.BLANK,
        },
      },
    });
  }

  toggleSettlement(invoiceId: string) {
    if (StringUtils.isEmpty(this.prevDropdown())) {
      this.prevDropdown.set(invoiceId);
    }
    if (this.prevDropdown() !== invoiceId) {
      this.isSettlementOpen[this.prevDropdown()] = false;
      this.prevDropdown.set(invoiceId);
    }
    this.isSettlementOpen[invoiceId] = !this.isSettlementOpen[invoiceId];
  }
  payNow(invoiceId?: string) {
    this.actionEvent({
      actionData: {
        type: !StringUtils.isEmpty(invoiceId)
          ? ActionEnum.PAY_INVOICE
          : ActionEnum.PAY_ALL_OUTSTANDING,
        params: !StringUtils.isEmpty(invoiceId)
          ? {
              invoiceId,
            }
          : null,
      },
    });
  }

  checkSettlements(transactions): boolean {
    if (!transactions) return false;
    return transactions.find((transactions) => transactions.settlement_date)
      ? true
      : false;
  }
}
